import { Model } from 'app/model/backendmodel';
import { IModel } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';

import { ManagedIntegrationRuntime, ManagedLinkedIntegrationRuntime } from 'app/model/integrationRuntime/managed.integrationRuntime';
import { irTypesConst } from 'app/integrationruntime/integrationruntime.constants';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { NamedAdapter } from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(ManagedLinkedIntegrationRuntime)
})
export class ManagedLinkedIntegrationRuntimeAdapter extends NamedAdapter<ManagedLinkedIntegrationRuntime, Model.IntegrationRuntimeResource> {

    public model(): IModel {
        return Metamodel.modelFor(ManagedIntegrationRuntime);
    }

    protected _toResource(ir: ManagedLinkedIntegrationRuntime): Model.IntegrationRuntimeResource {
        const modelIR = super._toResource(ir) as Model.IntegrationRuntimeResource;

        let modelIRLinkedProperties: Model.IntegrationRuntimeLinkedInfo | undefined;
        if (ir.sharedIROrigianlResourceId != null) {
            modelIRLinkedProperties = {
                resourceId: ir.sharedIROrigianlResourceId,
                sharedIntegrationRuntimeLocation: ir.sharedIntegrationRuntimeLocation
            };
        }

        const modelIRTypeProperties: Model.ManagedIntegrationRuntimeTypeProperties = {
            linkedInfo: modelIRLinkedProperties
        };

        const modelIRProperties: Model.ManagedIntegrationRuntime = {
            type: irTypesConst.SSIS,
            description: modelIR.properties ? modelIR.properties.description : undefined,
            typeProperties: modelIRTypeProperties
        };

        modelIR.properties = modelIRProperties;
        return modelIR;
    }

    protected _toModel(modelIRResource: Model.IntegrationRuntimeResource, integrationRuntime?: ManagedLinkedIntegrationRuntime): ManagedIntegrationRuntime {
        if (!integrationRuntime) {
            integrationRuntime = new ManagedIntegrationRuntime();
        }

        super._toModel(modelIRResource, integrationRuntime);

        const modelIRResourceProperties: Model.ManagedIntegrationRuntime = modelIRResource.properties as Model.ManagedIntegrationRuntime;

        if (modelIRResourceProperties.typeProperties.linkedInfo != null) {
            integrationRuntime.sharedIROrigianlResourceId = modelIRResourceProperties.typeProperties.linkedInfo.resourceId;
            integrationRuntime.sharedIntegrationRuntimeLocation = modelIRResourceProperties.typeProperties.linkedInfo.sharedIntegrationRuntimeLocation;
        }

        return integrationRuntime;
    }
}
